export const generateOfferCatalog = site => {
  const { categories } = site;

  const list = categories.map((i, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Service',
        name: i.name
      }
    };
  });
  return {
    '@type': 'OfferCatalog',
    name: `Services offered by ${site.name}`,
    itemListElement: list
  };
};
